export const ProfileImage = (imageName = "", imagePath = "") => {
    const baseUrl = process.env.REACT_APP_CDN_URL.replace("/media", "");
    if(imageName !== "" && imagePath !== ""){
        return `${baseUrl}${imagePath}/${imageName}`;
    }
    return null;
}